// extracted by mini-css-extract-plugin
var _1 = "line-clamp__saWzx";
export { _1 as "lineClamp" }
